import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserContext } from '@sierralabs/user-ui';
import { useSiteContext } from '../../SiteContext';
export function useSiteRouteAccess(path, routePermissions) {
    const { pathname } = useLocation();
    const { routeHasAccess } = useSiteContext();
    const { permissions, user } = useUserContext();
    const permission = useMemo(() => {
        const names = routePermissions || [];
        return (user &&
            (permissions === null || permissions === void 0 ? void 0 : permissions.find(permission => {
                // allow access even if some values were not provided
                return ((names.length === 0 || names.includes(permission.name)) &&
                    (!routeHasAccess || routeHasAccess(user, permission.name)));
            })));
    }, [permissions, routePermissions, user, routeHasAccess]);
    const hasAccess = useMemo(() => !!permission, [permission]);
    const redirectPath = useMemo(() => {
        return (permission === null || permission === void 0 ? void 0 : permission.redirectPath) || '/login';
    }, [permission]);
    const isInPath = useMemo(() => {
        const parts = path.split('/').filter(part => part);
        const locationParts = pathname.split('/').filter(part => part);
        return (parts.length === locationParts.length &&
            parts.every((part, index) => {
                return part.startsWith(':') || part === locationParts[index];
            }));
    }, [path, pathname]);
    return { isInPath, hasAccess, redirectPath };
}
//# sourceMappingURL=useSiteRouteAccess.js.map